// extracted by mini-css-extract-plugin
export default {"dialog-content":"dialog-content__ec6Q7","dialogContent":"dialog-content__ec6Q7","actions":"actions__sG+20","btn":"btn__IowLV"};